// src/admin/components/ThandizoLogo.tsx
// The three-bar mark from the brand guide. The "brand" variant sits inside a
// soft-cobalt rounded square (used in the sidebar / login). The "light"
// variant renders bare stripes for use against dark backgrounds.
//
// Proportions are tuned for visual balance at all sizes:
//   container = size × size, corner radius 22%
//   container padding 18% all sides
//   bar height 13%, gap 10% — three bars + two gaps fit inside the padded box
//   with ~5% breathing room top and bottom.
interface Props {
  size?: number;
  variant?: 'brand' | 'light';
}

export default function ThandizoLogo({ size = 28, variant = 'brand' }: Props) {
  const padding = size * 0.18;
  const barHeight = Math.max(2, Math.round(size * 0.13));
  const gap = Math.max(2, Math.round(size * 0.1));
  const colours = variant === 'light'
    ? ['#9CC5F0', '#60A5E8', '#2E82D6']
    : ['#9CC5F0', '#2E82D6', '#1260B0'];
  return (
    <span
      style={{
        width: size,
        height: size,
        display: 'inline-flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'stretch',
        gap,
        padding,
        background: variant === 'light' ? 'transparent' : 'var(--c-p50)',
        borderRadius: size * 0.22,
        flexShrink: 0,
        boxSizing: 'border-box',
      }}
      aria-hidden="true"
    >
      {colours.map((c, i) => (
        <span
          key={i}
          style={{
            width: '100%',
            height: barHeight,
            borderRadius: barHeight,
            background: c,
          }}
        />
      ))}
    </span>
  );
}
